import { apiGetClient, apiPostClient, apiPutClient } from "../../../api/apiSvtAdminCore";
import { toast } from 'react-toastify';
import i18n from "i18next";
const t = i18n.t.bind(i18n);

export const getAllLevels = async () => {
    try {
        const response = await apiGetClient.get("levels");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const createNewLevel = async (data) => {
    try {
        const response = await apiPostClient.post("levels", data);
    toast.success(t("levelCreatedSuccess", { name: data?.name }), { position: "top-center" });
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach(field => {
                errorData?.errors[field].forEach(message => {
                    toast.error(t("levelError", { message }), { position: "top-center" });
                });
            });
        } else {
            toast.error(t("levelError", { message: error.response.data?.error }), { position: "top-center" });
        }
        return null;
    }
};

export const updateLevel = async (data) => {
    try {
        const response = await apiPutClient.put(`levels/${data.id}`, data);
    toast.success(t("levelUpdatedSuccess", { name: data?.name }), { position: "top-center" });
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach(field => {
                errorData?.errors[field].forEach(message => {
                    toast.error(t("levelError", { message }), { position: "top-center" });
                });
            });
        } else {
            toast.error(t("levelError", { message: error.response.data?.error }), { position: "top-center" });
        }
        return null;
    }
};
